<template>
    <div>
        <div class="d-flex align-items-center mb-3" style="gap:8px;flex-wrap:wrap;">
            <label class="mb-0 mr-1"><i class="fas fa-sort-amount-down text-muted"></i> <b>Urutkan:</b></label>
            <select v-model="sortBy" @change="applySorting" class="form-control form-control-sm" style="width:auto;min-width:220px;">
                <option value="name_asc">Nama (A → Z)</option>
                <option value="name_desc">Nama (Z → A)</option>
                <option value="newest">Terbaru dibuat</option>
                <option value="oldest">Terlama dibuat</option>
                <option value="contacts_desc">Kontak Aktif (Terbanyak)</option>
                <option value="contacts_asc">Kontak Aktif (Tersedikit)</option>
                <option value="steps_desc">Jumlah Step (Terbanyak)</option>
                <option value="priority_desc">Prioritas (Tertinggi)</option>
                <option value="priority_asc">Prioritas (Terendah)</option>
                <option value="active_first">Status (Aktif dulu)</option>
            </select>
            <small class="text-muted">Klik judul kolom juga bisa untuk mengurutkan</small>
        </div>
        <vue-good-table mode="local"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <router-link :to="{ name: 'FollowUpEdit', query: { id: props.row.id } }" class="btn btn-primary text-white margin5">
                        <i class="fas fa-edit"></i> Edit
                    </router-link>
                    <button v-on:click="duplicateFollowUp(props.row)" class="btn btn-info text-white margin5">
                        <i class="fas fa-copy"></i> Duplikat
                    </button>
                    <button v-on:click="deleteFollowUp(props.row)" class="btn btn-danger text-white margin5">
                        <i class="fas fa-trash"></i> Hapus
                    </button>
                </span>
                <span v-else-if="props.column.field == 'is_active'">
                    <span v-if="props.row.is_active == 1" class="badge badge-success">Aktif</span>
                    <span v-else class="badge badge-danger">Nonaktif</span>
                </span>
                <span v-else-if="props.column.field == 'trigger_tag'">
                    <span class="badge badge-info">{{ props.row.trigger_tag || '-' }}</span>
                </span>
                <span v-else-if="props.column.field == 'priority'">
                    <span v-if="props.row.priority > 0" :title="props.row.priority + ' / 5'">
                        <span v-for="n in 5" :key="n" :style="{ color: n <= props.row.priority ? '#f5a623' : '#d0d0d0' }">★</span>
                    </span>
                    <span v-else class="text-muted">-</span>
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sortBy: "newest",
            table: {
                isLoading: false,
                columns: [
                    { label: 'Nama Follow Up', field: 'name', sortable: true,
                        sortFn(x, y) { return (x || '').toString().localeCompare((y || '').toString(), undefined, { numeric: true, sensitivity: 'base' }); } },
                    { label: 'Prioritas', field: 'priority', sortable: true, type: 'number' },
                    { label: 'Tag Pemicu', field: 'trigger_tag', sortable: true },
                    { label: 'Jumlah Step', field: 'total_steps', sortable: true, type: 'number' },
                    { label: 'Status', field: 'is_active', sortable: true },
                    { label: 'Kontak Aktif', field: 'active_contacts', sortable: true, type: 'number' },
                    { label: 'Aksi', field: 'action', sortable: false }
                ],
                rows: [],
                total_records: 0,
                serverParams: {
                    page: 1,
                    limit: 1000,
                    columnFilters: {}
                }
            }
        };
    },
    beforeDestroy() {
        this.$root.$off("refresh_table", this.fn);
    },
    mounted() {
        this.fn = () => {
            this.loadItems();
        };
        this.$root.$on("refresh_table", this.fn);
    },
    methods: {
        async loadItems() {
            this.table.isLoading = true;
            try {
                const params = {
                    page: this.table.serverParams.page,
                    limit: this.table.serverParams.limit,
                    columnFilters: JSON.stringify(this.table.serverParams.columnFilters)
                };
                let response = await this.$store.dispatch("followup/followup_list", params);
                this.table.rows = response.data.data.follow_ups || [];
                this.table.total_records = response.data.data.total || 0;
                this.applySorting();
            } catch (err) {
                this.$toast.error("Gagal memuat data");
            } finally {
                this.table.isLoading = false;
            }
        },
        applySorting() {
            const s = this.sortBy;
            const rows = [...this.table.rows];
            const num = (v) => parseInt(v) || 0;
            const str = (v) => (v || "").toString();
            // natural sort: angka di nama urut benar (1,2,...,9,10,11 — bukan 1,10,11,2)
            const natCmp = (x, y) => str(x).localeCompare(str(y), undefined, { numeric: true, sensitivity: 'base' });
            rows.sort((a, b) => {
                switch (s) {
                    case "name_asc": return natCmp(a.name, b.name);
                    case "name_desc": return natCmp(b.name, a.name);
                    case "newest": return num(b.created_at) - num(a.created_at);
                    case "oldest": return num(a.created_at) - num(b.created_at);
                    case "contacts_desc": return num(b.active_contacts) - num(a.active_contacts);
                    case "contacts_asc": return num(a.active_contacts) - num(b.active_contacts);
                    case "steps_desc": return num(b.total_steps) - num(a.total_steps);
                    case "priority_desc": return num(b.priority) - num(a.priority);
                    case "priority_asc": return num(a.priority) - num(b.priority);
                    case "active_first": return num(b.is_active) - num(a.is_active);
                    default: return 0;
                }
            });
            this.table.rows = rows;
        },
        async duplicateFollowUp(row) {
            if (!confirm(`Duplikat follow up "${row.name}"?`)) return;
            try {
                // Get full follow up data
                const response = await this.$store.dispatch("followup/followup_one", row.id);
                const followUp = response.data.data.follow_up;
                
                // Create new follow up with same data
                const newData = {
                    name: followUp.name + " (Copy)",
                    trigger_tag: followUp.trigger_tag,
                    trigger_type: followUp.trigger_type,
                    trigger_condition: followUp.trigger_condition,
                    is_active: 0,
                    steps: followUp.steps.map(step => ({
                        step_order: step.step_order,
                        delay_type: step.delay_type,
                        delay_value: step.delay_value,
                        message: step.message,
                        media_url: step.media_url,
                        button_text: step.button_text,
                        button_url: step.button_url,
                        template_id: step.template_id
                    }))
                };
                
                await this.$store.dispatch("followup/followup_create", newData);
                this.$toast.success("Follow up berhasil diduplikat");
                this.loadItems();
            } catch (err) {
                this.$toast.error("Gagal menduplikat follow up");
            }
        },
        async deleteFollowUp(row) {
            if (!confirm(`Hapus follow up "${row.name}"?`)) return;
            try {
                await this.$store.dispatch("followup/followup_delete", row.id);
                this.$toast.success("Follow up berhasil dihapus");
                this.loadItems();
            } catch (err) {
                this.$toast.error("Gagal menghapus follow up");
            }
        }
    }
};
</script>

<style scoped>
.margin5 {
    margin: 2px;
}
</style>


